// extracted by mini-css-extract-plugin
module.exports = {"list":"Operations_list__49G2v","item":"Operations_item__Vc8PZ","description":"Operations_description__75_vb","button":"Operations_button__YBvgV"};